import {useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';

import {Config} from 'redux/actions';

const useConfig = (props = {}) => {
	const {
		init = false
	} = props;

	const dispatch = useDispatch();
	const {fetching, loaded, data} = useSelector((state) => state.config);

	useEffect(() => {
		if (init) {
			dispatch(Config.get());
		}
	}, [dispatch, init]);


	return {
		loaded,
		fetching,
		fontFamilies: data.families,
		sizesText: data.sizesText,
		user: data.currentUser
	};
};

export default useConfig;
